import { action } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import { MrbSelectStore } from "mrb/components/select";
import { isNil } from "lodash";

class EditLoadioStoreFeaturedSectionContentViewStore extends MrbBaseViewStore {
    item = {};
    onUpdate = null;
    shouldAdd = false;
    addItem = null;

    constructor(rootStore, { routeStore, item, onUpdate, shouldAdd, addItem }) {
        super(rootStore);
        this.routeStore = routeStore;
        this.item = item || {};
        this.onUpdate = onUpdate;
        this.shouldAdd = shouldAdd;
        this.addItem = addItem;

        this.contentSelectStore = new MrbSelectStore({
            isSearchable: true,
            textKey: "title",
            valueKey: "id",
            initFetch: false,
            actions: {
                find: (searchTerm, pageNumber, pageSize) => {
                    return this.routeStore.getContent({
                        search: searchTerm,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    });
                },
                mapItem: (item) => {
                    return {
                        label: item.title,
                        value: item.loadioArtistId || item.loadioAlbumId,
                        item: item,
                    };
                },
            },
        });
        this.onSelectItem = this.onSelectItem.bind(this);
    }

    @action.bound
    onSelectItem() {
        const item = this.contentSelectStore.selectedItem;

        this.updateItem(item);
        this.contentSelectStore.clearOptions();
        this.contentSelectStore.clear();
        this.contentSelectStore.filter();
    }

    @action.bound
    updateItem(item) {
        this.item.loadioArtistId = null;
        this.item.loadioArtist = null;
        this.item.loadioAlbumId = null;
        this.item.loadioAlbum = null;
        if (!isNil(item.loadioArtistId)) {
            this.item.loadioArtistId = item.loadioArtistId;
            this.item.loadioArtist = {
                id: item.loadioArtistId,
                name: item.title,
                coverImageId: item.coverImageId,
            };
        } else if (!isNil(item.loadioAlbumId)) {
            this.item.loadioAlbumId = item.loadioAlbumId;
            this.item.loadioAlbum = {
                id: item.loadioAlbumId,
                title: item.title,
                coverImageId: item.coverImageId,
            };
        }

        if (this.shouldAdd) {
            this.addItem(this.item);
        }

        this.onUpdate();
    }
}

export default EditLoadioStoreFeaturedSectionContentViewStore;
